export default {
    PHONE_LANDSCAPE: 'only screen and (max-width:900px)', // includes iPhone XS Max
    PHONE_AND_TABLET: 'screen and (min-width: 1024px)', // includes iPad
};
